export const RESET_FLOW = 'RESET_FLOW'

export const resetFlow = () => {
  return { type: RESET_FLOW }
}
